// The object this module exports takes the place of
// browserHistory from React Router v2.

import { createBrowserHistory } from 'history';

export default createBrowserHistory();
